<template>
  <!-- mobile -->
  <li v-if="!$root.isDesktop" :class="['menu-item', { active: $attrs.active }]">
    <component :is="linkAttrs.href ? 'a' : 'span'" class="item-link" v-bind="linkAttrs" @click="gotoHandler">
      <span><slot /></span><lazy-icon v-if="$attrs.hasSublevel" icon="caret-right" scale="0.65" />
    </component>
  </li>

  <!-- desktop -->
  <li
    v-else
    :class="['menu-item', { active: $attrs.active, hover, 'has-sublevel': $attrs.hasSublevel }]"
    @mouseenter="hoverHandler(true)"
    @mouseleave="hoverHandler(false)"
  >
    <component :is="linkAttrs.href ? 'a' : 'span'" class="item-link" v-bind="linkAttrs">
      <slot />
    </component>

    <header-menu-level v-if="this.hover && $attrs.level && $attrs.level.depth <= 2" :level="$attrs.level" />
  </li>
</template>

<script>
export default {
  name: 'HeaderMenuItem',
  inheritAttrs: false,
  components: {
    HeaderMenuLevel: () => import('@/components/public/layout/HeaderMenuLevel')
  },
  props: {
    hardHover: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      hover: this.$props.hardHover
    }
  },
  computed: {
    linkAttrs() {
      return Object.assign({}, this.$attrs, {
        active: undefined,
        text: undefined,
        img: undefined,
        level: undefined
      })
    }
  },
  methods: {
    gotoHandler(event) {
      this.$emit('menuitem:goto', {
        event,
        hasSublevel: this.$attrs.hasSublevel,
        levelId: this.$attrs.hasSublevel ? this.$attrs.level.id : null
      })
    },
    hoverHandler(state = null) {
      if (!this.$props.hardHover) {
        this.hover = state !== null ? state : !this.hover
      }

      this.$emit(`menuitem:${this.hover ? 'hover' : 'blur'}`, this.$attrs)
    }
  },
  created() {
    this.$root.$on('headermenulevel:close', () => {
      this.hoverHandler(false)
    })
  },
  watch: {
    '$props.hardHover'() {
      this.hover = this.$props.hardHover
    }
  }
}
</script>

<style lang="scss">
// mobile
$headermenu-item-link-padding-y: $spacer * 0.5 !default;
$headermenu-item-link-padding-x: 0 !default;
$headermenu-item-link-border: map-get($borders, 'base') !default;
$headermenu-item-link-color: $body-color !default;

// desktop
$headermenu-item-breakpoint: $desktop-breakpoint !default;

$headermenu-item-desktop-margin: 0 !default;
$headermenu-item-desktop-link-gap: $spacer * 1.8 !default;
$headermenu-item-desktop-link-padding-y: 0 !default;
$headermenu-item-desktop-link-padding-x: $spacer * 0.75 !default;
$headermenu-item-desktop-link-color: $headermenu-item-link-color !default;
$headermenu-item-desktop-link-line-height: 1.1 !default;

$headermenu-item-desktop-link-hover-border: set-nth(map-get($borders, 'header'), 3, $primary) !default;

$headermenu-item-desktop-level1-margin: 0 !default;
$headermenu-item-desktop-level1-link-gap: 0 !default;
$headermenu-item-desktop-level1-link-padding-y: $spacer * 0.1 !default;
$headermenu-item-desktop-level1-link-padding-x: $spacer * 0.75 !default;
$headermenu-item-desktop-level1-link-color: $headermenu-item-desktop-link-color !default;
$headermenu-item-desktop-level1-link-line-height: inherit !default;

.header-menu {
  @include media-breakpoint-down(get-breakpoint-key($headermenu-item-breakpoint, -1)) {
    .menu-item {
      > .item-link {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 0;
        padding: $headermenu-item-link-padding-y $headermenu-item-link-padding-x;
        border-bottom: $headermenu-item-link-border;
        color: $headermenu-item-link-color;
        text-decoration: none;
      }
    }
  }

  @include media-breakpoint-up($headermenu-item-breakpoint) {
    .menu-item {
      margin: $headermenu-item-desktop-margin;

      > .item-link {
        display: block;
        margin-top: $headermenu-item-desktop-link-gap * 0.5;
        margin-bottom: $headermenu-item-desktop-link-gap * 0.5;
        padding: $headermenu-item-desktop-link-padding-y $headermenu-item-desktop-link-padding-x;
        color: $headermenu-item-desktop-link-color;
        line-height: $headermenu-item-desktop-link-line-height;
        text-decoration: none;
      }

      &.active,
      &.hover {
        > .item-link {
          margin-left: nth($headermenu-item-desktop-link-hover-border, 1) * -1;
          border-left: $headermenu-item-desktop-link-hover-border;
          font-weight: $font-weight-medium;
        }
      }
    }

    .level-1 {
      > .level-content {
        > ul {
          > .menu-item {
            display: flex;
            justify-content: center;
            align-items: center;
            margin: $headermenu-item-desktop-level1-margin;

            > .item-link {
              margin-top: $headermenu-item-desktop-level1-link-gap * 0.5;
              margin-bottom: $headermenu-item-desktop-level1-link-gap * 0.5;
              padding: $headermenu-item-desktop-level1-link-padding-y $headermenu-item-desktop-level1-link-padding-x;
              color: $headermenu-item-desktop-level1-link-color;
              line-height: $headermenu-item-desktop-level1-link-line-height;
            }

            &.hover,
            &.active {
              > .item-link {
                margin-left: 0;
                border-left: 0 none;
                margin-bottom: nth($headermenu-item-desktop-link-hover-border, 1) * -1;
                border-bottom: $headermenu-item-desktop-link-hover-border;
              }
            }
          }
        }
      }
    }
  }
}
</style>
